import { Component, ChangeDetectionStrategy, OnDestroy, OnInit, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { PrivilegesFacade } from '@app/store/privileges';
import { ProductsSyncService } from '@app/products';
import { fromEvent, Subscription } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { HeaderComponent } from '../header/header.component';
import { SideNavigationComponent } from '../container/side-navigation.component';
import { FooterComponent } from '../footer/footer.component';
@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ProductsSyncService],
    imports: [HeaderComponent, SideNavigationComponent, RouterOutlet, FooterComponent],
})
export class MainLayoutComponent implements OnDestroy, OnInit {
    private privilegesFacade = inject(PrivilegesFacade);
    private productsSyncService = inject(ProductsSyncService);
    private router = inject(Router);

    private subscribtions = new Subscription();
    ngOnInit(): void {
        this.productsSyncService.init();

        this.subscribtions.add(
            fromEvent<StorageEvent>(window, 'storage')
                .pipe(
                    filter((evt) => evt.key === 'logged'),
                    tap(() => {
                        const isLogged = localStorage.getItem('logged');

                        if (isLogged === 'false') void this.router.navigate(['/logout']);
                    }),
                )
                .subscribe(),
        );
    }

    ngOnDestroy(): void {
        this.privilegesFacade.clear();
        this.subscribtions.unsubscribe();
    }
}
